export const products = [
  {
    id: 'p1',
    name: 'The Modular Bloom Set',
    description: 'Our signature leak-proof system with adjustable dividers.',
    price: 34.00,
    category: 'box',
    rating: 4.9,
    reviews: 1240,
    image: 'https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?auto=format&fit=crop&q=80&w=800',
    tag: 'Bestseller'
  },
  {
    id: 'p2',
    name: 'Sproutling Mini Box',
    description: 'Perfectly portioned for smaller appetites and tiny hands.',
    price: 24.00,
    category: 'box',
    rating: 4.8,
    reviews: 850,
    image: 'https://images.unsplash.com/photo-1582401656496-9d75f95f9018?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'p3',
    name: 'Rainbow Nesting Cups',
    description: 'Food-grade silicone separators for organized snacking.',
    price: 18.00,
    category: 'accessories',
    rating: 5.0,
    reviews: 2100,
    image: 'https://images.unsplash.com/photo-1596560548464-f010549b84d7?auto=format&fit=crop&q=80&w=800',
    tag: 'Essentials'
  },
  {
    id: 'p4',
    name: 'Tokyo Teriyaki Kit',
    description: 'Includes artisanal sauce, sesame seeds, and 5-min prep guide.',
    price: 15.00,
    category: 'recipe-kit',
    rating: 4.7,
    reviews: 430,
    image: 'https://images.unsplash.com/photo-1543362906-acfc16c67564?auto=format&fit=crop&q=80&w=800',
    linkedRecipe: 'r1'
  },
  {
    id: 'p5',
    name: 'The Full Week Suite',
    description: '5 Boxes + 2 Accessory sets. The ultimate prep workspace.',
    price: 145.00,
    category: 'bundle',
    rating: 4.9,
    reviews: 320,
    image: 'https://images.unsplash.com/photo-1498837167922-41c46b3f6162?auto=format&fit=crop&q=80&w=800',
    tag: 'Save 20%'
  },
  {
    id: 'p6',
    name: 'Insulated Bloom Tote',
    description: 'Water-resistant, triple-insulated, and stylishly slim.',
    price: 28.00,
    category: 'accessories',
    rating: 4.6,
    reviews: 560,
    image: 'https://images.unsplash.com/photo-1622560022107-68b6d8b671a5?auto=format&fit=crop&q=80&w=800',
  }
];

export const recipes = [
  {
    id: 'r1',
    title: 'Sesame Ginger Crunch Bowl',
    prepTime: '12 mins',
    difficulty: 'Easy',
    calories: '420 kcal',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=800',
    requires: ['p1', 'p4']
  },
  {
    id: 'r2',
    title: 'Garden Pinwheel Wraps',
    prepTime: '10 mins',
    difficulty: 'Beginner',
    calories: '310 kcal',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80&w=800',
    requires: ['p2', 'p3']
  },
  {
    id: 'r3',
    title: 'Protein-Packed Pesto Pasta',
    prepTime: '18 mins',
    difficulty: 'Intermediate',
    calories: '550 kcal',
    image: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&q=80&w=800',
    requires: ['p1']
  }
];

export const faqs = [
  {
    q: "Are the materials safe for my family?",
    a: "Absolutely. Every Bento Bloom product is BPA-free, BPS-free, and phthalate-free. We use high-quality, food-grade silicone and recycled plastic components."
  },
  {
    q: "What is included in a Recipe Kit?",
    a: "Our kits include non-perishable pantry essentials like artisanal sauces, spice blends, and garnish packs, plus a waterproof recipe card."
  },
  {
    q: "How do I care for my Bloom products?",
    a: "All our boxes are top-rack dishwasher safe. To keep them looking new for years, we recommend hand-washing the lids and outer shells."
  }
];